import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function PondererPage() {

  return (
    <ProjectLayout
      title="Ponderer"
      role="Unity Developer (C#) - VR (Quest 3 - Hand Tracking)"
      team="1"
      duration="3 Months"
      engine="Unity (C#) - Mixed Reality, ESP32 Embedded (C++)"
      about="Ponderer is a mixed reality meditative LED installation that premiered at the Temple Playgrounds artist residency in Montreal, QC."
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/pondererClips.mp4`}
      playLink={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/Ponderer_Edited_Transitions.mp4`}
      playText={"Full Demo Video"}
      galleryImages = {[
    `${process.env.PUBLIC_URL}/img/ponderer/1.jpeg`,
    `${process.env.PUBLIC_URL}/img/ponderer/2.jpeg`,
    `${process.env.PUBLIC_URL}/img/ponderer/3.jpeg`,
    `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/pondUserVid1.mp4`,
    `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/pondUserVid2.mp4`,
    `https://neurogoblin-videos.s3.us-east-2.amazonaws.com/pondUserVid3.mp4`,
  ]}
    >
      <section>
        <h2>About</h2>
        <p>
          Ponderer is a mixed-reality meditation installation. It takes the user on a deep, introspective inner journey through the manipulation and pondering of magical orbs in their augmented perception. The world of the ponderer shifts seamlessly between normal waking life, and a deep meditative state accompanied by entrancing virtual environments. The installation also includes a system of programmable LEDs that react to the user's actions in the virtual world, to amplify their sense of magic, immersion, introspection, and play!
        </p>
      </section>

      {/* <section>
        <h2>What I Learned</h2>
        <p>
          Being a solo developer, Neuromersiv was a great opportunity to develop
          my skills as an independent developer, allowing greater creative
          control and decision making over the technical aspects of the
          platform. It was extremely rewarding to see real stroke patients using
          the platform and noticing their improvements (however slight) in real
          time. Unfortunately, Neuromersiv went out of business in mid 2025.
        </p>
      </section> */}

    
    </ProjectLayout>
  );
}
